import Lottie from 'lottie-react'
import React from 'react'
import styled from 'styled-components'
import { MultiSectionDigitalClock } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { CPPTimeSelectorContainer } from './createPlanPageStyles'

export const CPPTimeSelector = ({ value, setValueFunction }) => {
  return (
    <CPPTimeSelectorContainer>
      <MultiSectionDigitalClock
        defaultValue={dayjs(value)}
        onChange={(newValue) => setValueFunction(dayjs(newValue).format('YYYY-MM-DD HH:mm:ss'))}
      />
    </CPPTimeSelectorContainer>
  )
}

//for lottie

export const CPPCustomLottie = styled(Lottie)`
  width: 200px;
  height: 200px;
`
